module.exports = __webpack_public_path__ + "img/common-empty.ddc09945.png";